/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import SoftDatePicker from "components/SoftDatePicker";
import SoftButton from "components/SoftButton";
import SoftBox from "components/SoftBox";
import Footer from "./footer";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
  fontSize: "14px",
};

const Th = ({ children, style, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};
const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style, fontWeight: row.bold ? "bold" : 400 }}>
      {children}
    </th>
  );
};

const dataTable = [
  {
    bold: false,
    id: {
      value: 1,
      bg: false,
    },
    jobContent: {
      value: "",
      bg: false,
    },
    name: {
      value: "",
      bg: false,
    },
    subcontractorName: {
      value: "",
      bg: false,
    },
    subcontractorId: {
      value: "",
      bg: false,
    },
    number: {
      value: "",
      bg: false,
    },
    date: {
      value: "",
      bg: false,
    },
    payment: {
      value: 0,
      bg: false,
    },
    paymentDate: {
      value: "",
      bg: false,
    },
    revenueTNDN: {
      value: 0,
      bg: false,
    },
    percentTNDN: {
      value: "0.00",
      bg: false,
    },
    exemptionsTax: {
      value: 0,
      bg: false,
    },
  },
];

export default function TaxPersonalTable({ formData, setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value } = values;

    setData((prev) =>
      prev.map((item) => {
        if (item.id.value === id) {
          return { ...item, [name]: { ...item[name], value } };
        }
        return item;
      })
    );
  };

  const getMaxIdValue = () => {
    return Math.max(...data.map((item) => item.id.value), 0);
  };

  const options = [
    { value: "Dịch vụ, cho thuê máy móc thiết bị, bảo hiểm"},
    { value: "Xây dựng, lắp đặt không bao thầu nguyên vật liệu, máy móc, thiết bị"},
    { value: "Sản xuất, vận tải, dịch vụ có gắn với hàng hoá"},
    { value: "Xây dựng, lắp đặt có bao thầu nguyên vật liệu, máy móc, thiết bị"},
    { value: "Hoạt động kinh doanh khác"},
    { value: "Thương mại: phân phối, cung cấp hàng hoá, nguyên liệu, vật tư, máy móc, thiết bị"},
    { value: "Thương mại: phân phối, cung cấp hàng hoá, nguyên liệu, vật tư, máy móc, thiết bị gắn với dịch vụ thương mại"},
    { value: "Dịch vụ, cho thuê máy móc thiết bị, bảo hiểm, thuê giàn khoan"},
    { value: "Dịch vụ quản lý nhà hàng, khách sạn, casino"},
    { value: "Dịch vụ tài chính phát sinh"},
    { value: "Cho thuê tàu bay, động cơ tàu bay, phụ tùng tàu bay, tàu biển"},
    { value: "Xây dựng, lắp đặt có bao thầu hoặc không bao thầu nguyên vật liệu, máy móc, thiết bị"},
    { value: "Hoạt động sản xuất, kinh doanh khác, vận chuyển (bao gồm vận chuyển đường biển, vận chuyển hàng hoá)"},
    { value: "Chuyển nhượng chứng khoán, chứng chỉ tiền gửi, tái bảo hiểm ra nước ngoài, hoa hồng nhượng tái bản quyền"},
    { value: "Lãi tiền vay"},
    { value: "Thu thập bản quyền"},
  ];

  const addNewRow = () => {
    const newIdValue = getMaxIdValue() + 1;

    const newRow = {
      bold: false,
      id: {
        value: newIdValue,
        bg: false,
      },
      jobContent: {
        value: "",
        bg: false,
      },
      name: {
        value: "",
        bg: false,
      },
      subcontractorName: {
        value: "",
        bg: false,
      },
      subcontractorId: {
        value: "",
        bg: false,
      },
      number: {
        value: "",
        bg: false,
      },
      date: {
        value: "",
        bg: false,
      },
      payment: {
        value: 0,
        bg: false,
      },
      paymentDate: {
        value: "",
        bg: false,
      },
      revenueTNDN: {
        value: 0,
        bg: false,
      },
      percentTNDN: {
        value: "0.00",
        bg: false,
      },
      exemptionsTax: {
        value: 0,
        bg: false,
      },
    };

    setData((prev) => [...prev, newRow]);
  };
  const removeRow = () => {
    if (data.length !== 1) {
      data.pop();
      const newRow = data;
      setData([...newRow]);
    }
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
          Đơn vị tiền: Đồng Việt Nam
        </Typography>
      </Box>
      <Box>
        <Box style={{ maxWidth: "100%", overflowX: "auto" }}>
          <table style={tableStyle}>
            <thead style={{ background: "#eaeae9" }}>
              <tr>
                <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="2">
                  Nội dung công việc
                </Th>
                <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="2">
                  Tên NNKD
                </Th>
                <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="2">
                  Tên nhà thầu phụ (nếu có)
                </Th>
                <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="2">
                  Mã số thuế của nhà thầu phụ (nếu có)
                </Th>
                <Th style={{ textAlign: "center", fontWeight: "bold" }} colSpan="2">
                  Hợp đồng
                </Th>
                <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="2">
                  Số tiền thanh toán kì này
                </Th>
                <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="2">
                  Ngày thanh toán
                </Th>
                <Th style={{ textAlign: "center", fontWeight: "bold" }} colSpan="4">
                  Thuế thu nhập doanh nghiệp (TNDN)
                </Th>
              </tr>
              <tr>
                <Th style={{ textAlign: "center", fontWeight: "bold" }}>Số</Th>
                <Th style={{ textAlign: "center", fontWeight: "bold" }}>Ngày /tháng /năm</Th>
                <Th style={{ textAlign: "center", fontWeight: "bold" }}>Doanh thu tính thuế</Th>
                <Th style={{ textAlign: "center", fontWeight: "bold" }}>Tỷ lệ % thuế TNDN</Th>
                <Th style={{ textAlign: "center", fontWeight: "bold" }}>
                  Số thuế được miễn giảm theo Hiệp định
                </Th>
                <Th style={{ textAlign: "center", fontWeight: "bold" }}>Thuế TNDN phải nộp</Th>
              </tr>
              <tr>
                <Th style={{ textAlign: "center" }}>(1a)</Th>
                <Th style={{ textAlign: "center" }}>(1b)</Th>
                <Th style={{ textAlign: "center" }}>(2)</Th>
                <Th style={{ textAlign: "center" }}>(3)</Th>
                <Th style={{ textAlign: "center" }}>(4)</Th>
                <Th style={{ textAlign: "center" }}>(5)</Th>
                <Th style={{ textAlign: "center" }}>(6)</Th>
                <Th style={{ textAlign: "center" }}>(7)</Th>
                <Th style={{ textAlign: "center" }}>(8)</Th>
                <Th style={{ textAlign: "center" }}>(9)</Th>
                <Th style={{ textAlign: "center" }}>(10)</Th>
                <Th style={{ textAlign: "center" }}>{"{11=(8x9)-10}"}</Th>
              </tr>
            </thead>
            <tbody>
              {data &&
                data.length > 0 &&
                data.map((row, index) => (
                  <tr key={row.id.value}>
                    <Td
                      row={row}
                      style={{
                        textAlign: "center",
                        background: !row.jobContent.bg ? "transparent" : "#ddeff3",
                      }}
                    >
                      {row.jobContent.bg ? (
                        row.jobContent.value
                      ) : (
                        <InputTable
                          id={row.id.value}
                          name="jobContent"
                          value={row.jobContent.value}
                          onChange={handleChange}
                        />
                      )}
                    </Td>
                    <Td
                      row={row}
                      style={{
                        background: !row.name.bg ? "transparent" : "#ddeff3",
                      }}
                    >
                      {row.name.bg ? (
                        row.name.value
                      ) : (
                        <select
                          style={{
                            textAlign: "left",
                            fontSize: 14,
                            color: "#344767",
                            border: "none",
                            width: "200px",
                            background: "transparent",
                            padding: "4px 4px 4px 4px",
                          }}
                          onChange={(e) => handleChange({id: row.id.value, value: e.target.value, name: "name"})}
                        >
                          <option value="">--</option>
                          {options.map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.value}
                            </option>
                          ))}
                        </select>
                      )}
                    </Td>
                    <Td
                      row={row}
                      style={{
                        background: !row.subcontractorName.bg ? "transparent" : "#ddeff3",
                      }}
                    >
                      {row.subcontractorName.bg ? (
                        row.subcontractorName.value
                      ) : (
                        <InputTable
                          id={row.id.value}
                          name="subcontractorName"
                          value={row.subcontractorName.value}
                          onChange={handleChange}
                        />
                      )}
                    </Td>
                    <Td
                      row={row}
                      style={{
                        background: !row.subcontractorId.bg ? "transparent" : "#ddeff3",
                      }}
                    >
                      {row.subcontractorId.bg ? (
                        row.subcontractorId.value
                      ) : (
                        <InputTable
                          id={row.id.value}
                          name="subcontractorId"
                          value={row.subcontractorId.value}
                          onChange={handleChange}
                          type="number"
                        />
                      )}
                    </Td>
                    <Td
                      row={row}
                      style={{
                        textAlign: "right",
                        background: !row.number.bg ? "transparent" : "#ddeff3",
                      }}
                    >
                      {row.number.bg ? (
                        row.number.value
                      ) : (
                        <InputTable
                          id={row.id.value}
                          name="number"
                          value={row.number.value}
                          onChange={handleChange}
                          type="number"
                        />
                      )}
                    </Td>
                    <Td
                      row={row}
                      style={{
                        textAlign: "right",
                        background: !row.date.bg ? "transparent" : "#ddeff3",
                      }}
                    >
                      {row.date.bg ? (
                        row.date.value
                      ) : (
                        <InputTable
                          id={row.id.value}
                          name="date"
                          value={row.date.value}
                          onChange={handleChange}
                          type="date"
                        />
                      )}
                    </Td>
                    <Td
                      row={row}
                      style={{
                        textAlign: "right",
                        background: !row.payment.bg ? "transparent" : "#ddeff3",
                      }}
                    >
                      {row.payment.bg ? (
                        row.payment.value
                      ) : (
                        <InputTable
                          id={row.id.value}
                          name="payment"
                          value={row.payment.value}
                          onChange={handleChange}
                          type="number"
                        />
                      )}
                    </Td>
                    <Td
                      row={row}
                      style={{
                        textAlign: "right",
                        background: !row.paymentDate.bg ? "transparent" : "#ddeff3",
                      }}
                    >
                      {row.paymentDate.bg ? (
                        row.paymentDate.value
                      ) : (
                        <InputTable
                          id={row.id.value}
                          name="paymentDate"
                          value={row.paymentDate.value}
                          onChange={handleChange}
                          type="date"
                        />
                      )}
                    </Td>
                    <Td
                      row={row}
                      style={{
                        textAlign: "right",
                        background: !row.revenueTNDN.bg ? "transparent" : "#ddeff3",
                      }}
                    >
                      {row.revenueTNDN.bg ? (
                        row.revenueTNDN.value
                      ) : (
                        <InputTable
                          id={row.id.value}
                          name="revenueTNDN"
                          value={row.revenueTNDN.value}
                          onChange={handleChange}
                          type="number"
                        />
                      )}
                    </Td>
                    <Td
                      row={row}
                      style={{
                        textAlign: "right",
                        background: !row.percentTNDN.bg ? "transparent" : "#ddeff3",
                      }}
                    >
                      {row.percentTNDN.bg ? (
                        row.percentTNDN.value
                      ) : (
                        <InputTable
                          id={row.id.value}
                          name="percentTNDN"
                          value={row.percentTNDN.value}
                          onChange={handleChange}
                          type="decimal"
                        />
                      )}
                    </Td>
                    <Td
                      row={row}
                      style={{
                        textAlign: "right",
                        background: !row.exemptionsTax.bg ? "transparent" : "#ddeff3",
                      }}
                    >
                      {row.exemptionsTax.bg ? (
                        row.exemptionsTax.value
                      ) : (
                        <InputTable
                          id={row.id.value}
                          name="exemptionsTax"
                          value={row.exemptionsTax.value}
                          onChange={handleChange}
                          type="number"
                        />
                      )}
                    </Td>
                    <Td
                      row={row}
                      style={{
                        textAlign: "right",
                        background: "#ddeff3",
                      }}
                    >
                      {Math.round(
                        row.percentTNDN.value * row.revenueTNDN.value - row.exemptionsTax.value
                      )}
                    </Td>
                  </tr>
                ))}
              <tr>
                <Td colspan="3"
                  row={{ bold: true }}
                  style={{
                    textAlign: "center",
                    background: "#ddeff3",
                  }}
                >
                  Tổng cộng:
                </Td>
                <Td
                  row={{ bold: true }}
                  style={{
                    textAlign: "right",
                    background: "#ddeff3",
                  }}
                ></Td>
                <Td
                  row={{ bold: true }}
                  style={{
                    textAlign: "right",
                    background: "#ddeff3",
                  }}
                ></Td>
                <Td
                  row={{ bold: true }}
                  style={{
                    textAlign: "right",
                    background: "#ddeff3",
                  }}
                ></Td>
                <Td
                  row={{ bold: true }}
                  style={{
                    textAlign: "right",
                    background: "#ddeff3",
                  }}
                >
                  {data.reduce((total, item) => total + (item.payment.value | 0), 0)}
                </Td>
                <Td
                  row={{ bold: true }}
                  style={{
                    textAlign: "right",
                    background: "#ddeff3",
                  }}
                ></Td>
                <Td
                  row={{ bold: true }}
                  style={{
                    textAlign: "right",
                    background: "#ddeff3",
                  }}
                >
                  {data.reduce((total, item) => total + (item.revenueTNDN.value | 0), 0)}
                </Td>
                <Td
                  row={{ bold: true }}
                  style={{
                    textAlign: "right",
                    background: "#ddeff3",
                  }}
                ></Td>
                <Td
                  row={{ bold: true }}
                  style={{
                    textAlign: "right",
                    background: "#ddeff3",
                  }}
                >
                  {data.reduce((total, item) => total + (item.exemptionsTax.value | 0), 0)}
                </Td>
                <Td
                  row={{ bold: true }}
                  style={{
                    textAlign: "right",
                    background: "#ddeff3",
                  }}
                >
                  {Math.round(
                    Math.round(
                      data.reduce(
                        (total, item) =>
                          total +
                          item.revenueTNDN.value * item.percentTNDN.value -
                          item.exemptionsTax.value,
                        0
                      )
                    )
                  )}
                </Td>
              </tr>
            </tbody>
          </table>
        </Box>

        <SoftBox display="flex" justifyContent="flex-start" gap={3} mt={2}>
          <SoftButton variant="gradient" color="dark" onClick={addNewRow}>
            Thêm dòng
          </SoftButton>
          <SoftButton variant="gradient" color="light" onClick={removeRow}>
            Xóa dòng
          </SoftButton>
        </SoftBox>
        <Footer formData={formData} />
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, type, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;
  const regexDecimal = /^(0|0?\.\d*|1|1(\.0*)?)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value;
    if (type == "number") {
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name });
    } else if (type == "decimal") {
      if (!regexDecimal.test(newValue)) return;
      onChange({ id, value: newValue, name });
    } else {
      onChange({ id, value: newValue !== "" ? newValue : "", name });
    }
  }
  return (
    <input
      type={type == "date" ? "date" : ""}
      style={{
        textAlign: type == "number" || type == "decimal" ? "right" : "left",
        fontSize: 14,
        color: "#344767",
        border: "none",
        width: type == "date" ? "150px" : "100px",
        background: "transparent",
        padding: "4px 4px 4px 4px",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
